module.exports = __webpack_public_path__ + "img/locatorIcon.5ddbe932.png";